import { render, staticRenderFns } from "./MenuWithActivatorAndTooltip.vue?vue&type=template&id=438d97b0&"
import script from "./MenuWithActivatorAndTooltip.vue?vue&type=script&lang=js&"
export * from "./MenuWithActivatorAndTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports